<div class="backdrop" *ngIf="IsWaiting">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="card-body">
  <h5 class="d-flex justify-content-between align-items-center mb-3">
    <strong><span class="text-muted">Your Cart Summary</span></strong>
    <span class="grey-text small"></span>
  </h5>
  <hr />
  <form [formGroup]="promoCodeForm">
    <div class="input-group mb-3 pt-3">
      <div class="input-group-prepend">
        <button class="btn btn-md btn-outline-primary m-0 px-3 py-2 z-depth-0 waves-effect"
                type="button"
                id="button-addon1"
                style="text-transform: uppercase"
                data-testid="cart-page-apply-coupon"
                #promocodebutton
                (click)="calculateCoupon()">
          Apply Coupon
        </button>
      </div>
      <input type="text"
             mdbInput
             mdbValidate
             formControlName="promoCode"
             (keyup.enter)="promocodebutton.click()"
             class="form-control"
             data-testid="cart-page-enter-coupon"
             placeholder="Enter Coupon" />
    </div>
  </form>

  <app-checkout-summary [cartSummary]="model"></app-checkout-summary>

  <app-klarna-placement-wrapper></app-klarna-placement-wrapper>

  <div class="pt-3">
    <button mdbBtn
            style="border-width: 0px; text-transform: uppercase; padding: 0.84rem; color: white"
            type="button"
            gradient="blue"
            block="true"
            mdbWavesEffect
            data-testid="cart-page-checkout-btn"
            (click)="onCheckout()">
      <i class="fas fa-cart-plus"></i> Checkout
    </button>
    <br />

    <app-login #loginModal [isCheckout]="true"></app-login>
  </div>

  <div>
    <app-klarna-express-button-wrapper></app-klarna-express-button-wrapper>
  </div>
</div>
